import { reactNode } from '@shared/node-v1.0.0'

import v200 from '@nodes/action-icon-v2.0.0'

export default  reactNode(
	'ActionIcon',
	{
		'v2.0.0': v200,
	},
	{ allowChildren: false, docs: '' }
)
